
define('template!mailsMailRightCollapsedView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="attachments-region"></div>\n<div class="purchaseOrders-region"></div>';

}
return __p
};});

